export enum EChartAxis {
    X = 'x',
    Y = 'y'
}
